import React from 'react';
import '../../App.css'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Project from './project pages/ProjectHome';
import Checkers from './project pages/Checkers';
import Labyrinth from './project pages/Labyrinth';
import Models from './project pages/ModelsApp';
import ProjectRTSS from './project pages/ProjectRTSS';
import SalesForce from './project pages/Salesforce';
import SQLGUI from './project pages/SQLGUI';
import TicTacToe from './project pages/TicTacToe';

export default function Projects() {
    return ( 
        <Router>
            <Switch>
                <Route path='/DigitalPortfolio/projects' exact component={Project} />
                <Route path='/DigitalPortfolio/projects/Checkers' component={Checkers} />
                <Route path='/DigitalPortfolio/projects/Labyrinth' component={Labyrinth} />
                <Route path='/DigitalPortfolio/projects/Models' component={Models} />
                <Route path='/DigitalPortfolio/projects/ProjectRTSS' component={ProjectRTSS} />
                <Route path='/DigitalPortfolio/projects/SalesForce' component={SalesForce} />
                <Route path='/DigitalPortfolio/projects/SQL-GUI' component={SQLGUI} />
                <Route path='/DigitalPortfolio/projects/TicTacToe' component={TicTacToe} />
            </Switch>
        </Router>
        )
}